<div class="filter-quick flex vcenter">
  <button
    class="month-increment-button"
    payee-button
    (click)="addMonths(-1)"
  >
    -
  </button>
  <button
    payee-button
    width="shorter"
    (click)="quickFilter('current_month')"
  >
    Mostani hónap
  </button>
  <button
    class="month-increment-button"
    payee-button
    (click)="addMonths(1)"
  >
    +
  </button>
  <button
    payee-button
    width="shorter"
    (click)="quickFilter('ytd')"
  >
    YTD
  </button>
</div>

<form
  class="filter-form flex"
  [formGroup]="filterForm"
>
  <payee-form-field width="short">
    <span payee-label>Ettől a dátumtól kezdve</span>
    <payee-datepicker formControlName="from_date"></payee-datepicker>
  </payee-form-field>
  <payee-form-field width="short">
    <span payee-label>Eddig a dátumig</span>
    <payee-datepicker formControlName="to_date"></payee-datepicker>
  </payee-form-field>
  <button
    payee-button
    width="short"
    [disabled]="loading"
    (click)="refresh.next()"
  >
    Frissítés
  </button>
</form>

<app-case-starts-table
  [from_date]="from_date.value"
  [to_date]="to_date.value"
  [refresh]="refresh"
  (loadingChange)="updateLoading($event)"
></app-case-starts-table>

<app-case-starts-by-law-firm-table
  [from_date]="from_date.value"
  [to_date]="to_date.value"
  [refresh]="refresh"
  (loadingChange)="updateLoading($event)"
></app-case-starts-by-law-firm-table>

<app-case-fees-table
  [from_date]="from_date.value"
  [to_date]="to_date.value"
  [refresh]="refresh"
  (loadingChange)="updateLoading($event)"
></app-case-fees-table>
